import React, { useEffect, useState } from "react"
import BackOfficeAPIClient from "../../clients/BackofficeAPIClient"

interface UploadedFile
{
    file: string
    brand: string
}

export default function List() {
    const backofficeApiClient = new BackOfficeAPIClient()

    const [ autovistaBrands, setAutovistaBrands ] = useState<string[]>([])
    const [ logoRefreshKey, setLogoRefreshKey ] = useState(Date.now())
    const [ filterByName, setFilterByName ] = useState("")

    const fetchAutovistaBrands = async () => {
        try {
            return await backofficeApiClient.get<string[]>("/vmAuto/brands")
        } catch {
            throw new Error("Erreur lors de la récupération des marques Autovista.")
        }
    }

    const formatBrandName = (brand: string) => {
        return brand.toLowerCase().replace(/[^a-z0-9]/g, "")
    }

    const uploadFile = async (fileName: string, fileContent: string) => {
        try {
            await backofficeApiClient.post<UploadedFile>("/logosMarques", {
                file: fileContent,
                fileName,
            })
            await fetchData()
            setLogoRefreshKey(Date.now())
        } catch (e) {
            console.error("Error", e)
        }
    }

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>, brand: string) => {
        const file = event.target.files?.[0] as File | undefined
        if (!file) return

        if (file.type !== "image/png") {
            alert("Le fichier doit être au format PNG")
            return
        }
    
        const reader = new FileReader()
        reader.onload = async (e) => {
            await uploadFile(formatBrandName(brand), e.target?.result as string)
        }
        reader.readAsDataURL(file)
    }

    const fetchData = async () => {
        try {
            const brands = await fetchAutovistaBrands()
            const sortedBrands = brands.sort((a, b) => a.localeCompare(b, "fr", { sensitivity: "base" }))
            setAutovistaBrands(sortedBrands)
        } catch (error) {
            console.error("Erreur lors de la récupération des données :", error)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    const filteredBrands = autovistaBrands.filter((brand) =>
        brand.toLowerCase().includes(filterByName.toLowerCase())
    )

    return (
        <div className="container-fluid mb-2">
            <div className="row">
                <div className="col">
                    <h2 className="mb-4">Logos Marques</h2>
                    <div className="d-flex flex-column align-items-start" style={{ gap: "1em" }}>
                        <p style={{ fontSize: "0.9em", color: "gray" }}>Le seul format autorisé pour les logos des véhicules est le .png (PNG)</p>
                        <div className="d-flex flex-row">
                            <label htmlFor="filterBrandByName">Marque :</label>
                            <input id="filterBrandByName" type="text" className="ml-1" value={filterByName} onChange={(e) => setFilterByName(e.currentTarget.value)}/>
                        </div>

                        <table className="table table-striped table-hover table-sm">
                            <thead>
                            <tr>
                                <th>Marque</th>
                                <th>Logo</th>
                                <th>Upload</th>
                            </tr>
                            </thead>
                            <tbody>
                            {filteredBrands.map((brand, index) => {
                                return (
                                    <tr key={`${brand}_${index}`}>
                                        <td>{brand}</td>
                                        <td>
                                            <div>
                                                <div style={
                                                    {
                                                        backgroundImage: `url(https://skilliance.e-seller.selectup.com//DocumentsEDataVoice/_LogoMarques/${formatBrandName(brand)}.png?${logoRefreshKey})`,
                                                        backgroundRepeat: "no-repeat",
                                                        backgroundPosition: "center",
                                                        backgroundSize: "contain",
                                                        width: 150, height: 100,
                                                    }
                                                }></div>
                                            </div>
                                        </td>

                                        <td>
                                            <input type="file" accept="image/png" onChange={(e) => handleFileChange(e, filteredBrands[index])}/>
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}
